export var TimeSegment;

(function (TimeSegment) {
  TimeSegment["Hours"] = "hours";
  TimeSegment["Minutes"] = "minutes";
  TimeSegment["Seconds"] = "seconds";
  TimeSegment["Milliseconds"] = "milliseconds";
})(TimeSegment || (TimeSegment = {}));